import { useState, useRef } from 'react';

const useThrottledClick = (callback, throttleMs = 3000) => {
  const [loading, setLoading] = useState(false);
  const lastClickRef = useRef(0);

  const handler = async (...args) => {
    const now = Date.now();
    if (now - lastClickRef.current < throttleMs) {
      return;
    }
    lastClickRef.current = now;
    setLoading(true);
    try {
      await callback(...args);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return [handler, loading];
};

export default useThrottledClick;
